import Vue from "vue";
import store from "@/store/store";

import VBCHeader from "@/documents/vbc/header";
import VBCFooter from "@/documents/vbc/footer";
import VBCContent from "@/documents/vbc/content";

import moment from "moment";

export default function () {
  function generateTemplateVBC(
    meeting,
    mandate,
    pdfFooterMessage,
    majorities,
    pdfContactDetails,
    agencyEmail,
    votes
  ) {
    return new Promise(resolve => {
      let templateHeader = generateTemplate(VBCHeader, {
        meetingDate: formatDate(meeting.meeting_date),
        buildingName: meeting.building.name,
        logoInBase64: meeting.logoInBase64,
      });
      let templateFooter = generateTemplate(VBCFooter, {
        logoInBase64: meeting.logoInBase64,
        pdfFooterMessage: pdfFooterMessage,
      });
      let templateContent = generateTemplate(VBCContent, {
        meeting: {
          id: meeting.id,
          date: formatDate(meeting.meeting_date),
          last_reception_date: meeting.last_reception_date,
          allowed_modalities: meeting.allowed_modalities,
          address: meeting.address,
          access: meeting.access,
          external_video_solution: meeting.external_video_solution,
          show_connection_details: meeting.show_connection_details,
        },
        building: {
          name: meeting.building.name,
          address: meeting.building.address,
        },
        resolutions: meeting.meeting_resolutions,
        mandate: {
          building_owner: mandate.building_owner,
        },
        countries: getAllCountries(),
        majorities: majorities,
        pdfContactDetails: pdfContactDetails,
        agencyEmail: agencyEmail,
        votes: votes,
      });
      resolve({
        header: templateHeader,
        footer: templateFooter,
        content: templateContent,
      });
    });
  }

  /**
   *
   * @param {*} templateType
   * @param {*} props
   */
  function generateTemplate(templateType, props) {
    let Template = Vue.extend(templateType);
    let template = new Template({
      propsData: props,
      store, // NOTE: to be able to use this.$store from documents (for voting limit rules & meeting details info)
    });
    template.$mount();
    let html = template.$el.outerHTML;
    template.$destroy();
    return html;
  }

  /**
   * Creates an anchor element `<a></a>` with
   * the base64 pdf source and a filename with the
   * HTML5 `download` attribute then clicks on it.
   */
  function downloadDialog(doc, docName, docExtension) {
    const linkSource = `data:application/${docExtension};base64,${doc}`;
    const downloadLink = document.createElement("a");
    const fileName = docName + "." + docExtension;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  /**
   * Make sure format is utc and then displayed in local timezone
   * @param {*} meetingDate
   */
  function formatDate(meetingDate) {
    if (
      moment.parseZone(meetingDate).utcOffset() > 0 ||
      moment.parseZone(meetingDate).utcOffset() < 0
    ) {
      let utcFormatted = moment
        .parseZone(meetingDate)
        .utcOffset(0, true)
        .format("YYYY-MM-DDTHH:mm:ssZ");
      return moment(utcFormatted).format("YYYY-MM-DDTHH:mm:ssZ");
    } else {
      return moment(meetingDate).format("YYYY-MM-DDTHH:mm:ssZ");
    }
  }

  function getAllCountries() {
    return store.getters.getCountries;
  }

  return {
    generateTemplateVBC,
    downloadDialog,
  };
}
